.Skeleton {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  background-color: var(--accent);
  border-radius: var(--border-radius-md);
}

@keyframes pulse {
  0%,
  100% {
    opacity: 100%;
  }

  50% {
    opacity: 50%;
  }
}

/*
 * Sizing from the `height` / `width` props.
 *
 * Two classes rather than one, each applied only when its prop is given, so a
 * dimension the caller did not pass is never declared here and whatever their
 * own class says about it still stands.
 *
 * Qualified with `.Skeleton` deliberately: an explicit prop has to beat a
 * caller's single-class rule (`.SkeletonRow` and friends), and at equal
 * specificity that would come down to stylesheet order, which is the bundler's
 * business and not something to rely on.
 */
.Skeleton.HasHeight {
  height: var(--skeleton-height);
}

.Skeleton.HasWidth {
  width: var(--skeleton-width);
}
